import { useContext, useRef } from "react";
import { MainContext } from "../../../MainContext";
import "./AboutUs.scss";
import useScrollAnimation from "../../useAnimationScrolling";

export const AboutUs = () => {
	const {
		staticTexts: { aboutUs: staticTexts },
		aboutUsRef,
	} = useContext(MainContext);

	const animationConfig = {
		translateY: [50, 0],
		opacity: [0, 1],
		easing: "easeOutExpo",
		duration: 1500,
	};

	useScrollAnimation(aboutUsRef, animationConfig, staticTexts);

	return (
		<div className="about-us-container">
			<div className="banner">
				<div
					className="image-information"
					ref={(el) => {
						if (el) aboutUsRef.current[0] = el;
					}}
				>
					<div className="texts">
						<img src={`${staticTexts.image}`} alt="" />
						<div className="right">
							<div className="wrapper">
								<p className="typography">{staticTexts.title}</p>
								<hr />
								<p className="typography_small">{staticTexts.text}</p>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};
